var map = {
	"./blackFriday.png": "3fa7",
	"./bonus.png": "ef09",
	"./bonus_billingcert.png": "5e91",
	"./bonus_buh_certificate.png": "a257",
	"./bonus_cardholder.png": "1064",
	"./bonus_hoodie.png": "30f7",
	"./bonus_modult.png": "78f5",
	"./bonus_notepad.png": "9bbe",
	"./bonus_ozoncert.png": "36ee",
	"./bonus_pen.png": "5572",
	"./bonus_rkof.png": "101c",
	"./bonus_s7cert.png": "bc27",
	"./bonus_shopperbag.png": "5549",
	"./bonus_towel.png": "7729",
	"./bonus_tshirt.png": "707a",
	"./bonus_wildberriescert.png": "6573",
	"./bonus_yamarketcert.png": "7ef4",
	"./cheque.png": "83c3",
	"./docs.png": "a12d",
	"./geotarget.png": "94f5",
	"./img.png": "ba75",
	"./megaphone.png": "3513",
	"./new_year.png": "c51f",
	"./partner.png": "7113",
	"./prize_car.png": "7140",
	"./success.png": "d284",
	"./vector.png": "7308"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";